import { render, staticRenderFns } from "./RepresentanteTerritorial.vue?vue&type=template&id=93482a64"
import script from "./RepresentanteTerritorial.vue?vue&type=script&lang=js"
export * from "./RepresentanteTerritorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports